import React from "react";
import { useDispatch } from "react-redux";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { deleteUserDrivingPermit } from "Bands/state";

const { userDrivingPermit: permitCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserDrivingPermitModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserDrivingPermit(id));
  };

  return (
    <DeleteUserEntityModal
      type="driving permit"
      action={USER_ACTIONS.deleteUserDrivingPermit}
      successMessage={permitCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
